
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote-builder",
      function () {
        return require("private-next-pages/quote-builder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote-builder"])
      });
    }
  